<div #diagramContainer class="container" [@expandCollapseFromTop]="getExpandCollapseFromTop(diagramContainer)">
	@if (imageZoomToolLoaded && currentElement) {
		<stages-image-zoom
			#imgZoom
			[sourceChanged]="sourceChanged"
			[diagramLoaded]="diagramLoaded!"
			[isFirstDiagram]="isFirstDiagramOnPage"
			[isZoomToolSupported]="isBrowserSupported"
			[id]="diagramId!"
			[fitToPage]="fitToPage"
			[prefixedIdent]="config.prefixedIdent"
			[currentElementName]="currentElement.label"
			[imageMap]="imageMap"
			[src]="src!"
			[container]="diagramContainer"
		></stages-image-zoom>
	}
	@if (expanded && (!imageZoomToolLoaded || !currentElement || refreshingDiagram)) {
		<div style="height: 30px">
			<stages-spin size="sm"></stages-spin>
		</div>
	}
</div>
